module.exports = __webpack_public_path__ + "static/media/TonoDaruma_01C_03.140c82bb.png";